import Page from "components/base/Page";
import { Link } from "react-router-dom";

const CashflowPage = () => {
  return (
    <Page
      title="Cashflow Overview"
      staticHeader
      rightButtons={
        <div>
          <a
            href={process.env.REACT_APP_SERVER_ADMIN_URL + "accounting"}
            target="_blank"
          >
            Admin
          </a>
        </div>
      }
    >
      <div className="p-6 text-sm">
        <div>
          <p>
            We are building this page to provide an overview for cashflow
            forecasting. Click on a company to view.
          </p>
          <p>
            WIS fetches data from Odoo - payments, invoices, bills, sales
            orders, purchase orders, currency exchange rates.
          </p>
          <p>
            WIS also manages the recurring items and provides a comprehensive
            view of the company's financial health. To manage the recurring
            items, please go to admin by clicking the "Admin" link on the top
            right corner.
          </p>
          <p>Stella has confirmed that LTD is good enough for now to go.</p>
          <p>For AB we will need to continue to work on the details.</p>
          <p>
            The data will refresh once a day. You can manually refresh the data
            by clicking the "Refresh Data" button in the top right corner.
          </p>
        </div>
        <div className="flex space-x-6 mt-6">
          <Link to="ab">AB</Link>
          <Link to="ltd">LTD</Link>
        </div>
      </div>
    </Page>
  );
};

export default CashflowPage;
